import { LocalStorageKey } from '@diritto/common/utils/localStorage';

export enum UserProperties {
  UserId = 'userId',
  UserStatus = 'userStatus',
  SsoType = 'ssoType',
  IsAdult = 'isAdult',
  MktAgreement = 'mktAgreement',
  MktAgreementNight = 'mktAgreementNight',

  // arrays
  ProfileIds = 'profileIds',

  // viewer style
  ViewerTheme = 'viewerTheme',
  ViewerFont = 'viewerFont',
  ViewerFontSize = 'viewerFontSize',
  ViewerLineHeight = 'viewerLineHeight',
  ViewerParagraphIndent = 'viewerParagraphIndent',
  ViewerPadding = 'viewerPadding',
  ViewerIndentation = 'viewerIndentation',
}

export const ViewerUserPropertyNameMapper = {
  [LocalStorageKey.ViewerTheme]: UserProperties.ViewerTheme,
  [LocalStorageKey.ViewerFont]: UserProperties.ViewerFont,
  [LocalStorageKey.ViewerFontSize]: UserProperties.ViewerFontSize,
  [LocalStorageKey.ViewerLineHeight]: UserProperties.ViewerLineHeight,
  [LocalStorageKey.ViewerParagraphIndent]: UserProperties.ViewerParagraphIndent,
  [LocalStorageKey.ViewerPadding]: UserProperties.ViewerPadding,
  [LocalStorageKey.ViewerIndentation]: UserProperties.ViewerIndentation,
} as Record<string, UserProperties>;
